import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: LucideIcon
    title: string
    description?: string
    action?: ReactNode
    className?: string
}

export const EmptyState: FC<EmptyStateProps> = ({ icon: Icon, title, description, action, className }): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center justify-center px-6 py-14 text-center', className)}>
            <span className='flex size-12 items-center justify-center rounded-xl border bg-muted/60 text-muted-foreground'>
                <Icon className='size-5' aria-hidden='true' />
            </span>

            <p className='mt-4 text-sm font-semibold text-foreground'>
                {title}
            </p>

            {description && (
                <p className='mt-1 max-w-sm text-sm text-muted-foreground'>
                    {description}
                </p>
            )}

            {action && (
                <div className='mt-5'>
                    {action}
                </div>
            )}
        </div>
    )
}
